import React from 'react';
import { ImageTitle } from '../../core/ImageTitle';
import { StandardProductListComponent } from './Controls/StandardProductListComponent';
import { StandardProductEditorComponent } from './Controls/StandardProductEditorComponent';
import { StandardProductDetailsComponent } from './Controls/StandardProductDetailsComponent';

export class StandardProductHomeView extends React.Component {

    render() {
        return (
            <div className="view">
                <ImageTitle text='Standard Products' />
                <StandardProductListComponent/>
            </div>

        );
    }
}

export class StandardProductEditView extends React.Component {


    render() {
        return (
            <div className="view">
                <StandardProductEditorComponent user={this.props.user} dataId={this.props.param_0} isCopy={this.props.isCopy} />
            </div>
        );
    }
}

export class StandardProductDisplayView extends React.Component {


    render() {
        return (
            <div className="view">
                <StandardProductDetailsComponent user={this.props.user} dataId={this.props.param_0} />
            </div>
        );
    }
}